import "../styles/schedule-alert-modal.scss";
import moment from "moment";
import "moment-timezone";
import React, { useState } from "react";
import { formatDateLongScheduled, parseDate } from "../utilities/utilities";
import { Modal } from "./modal";
import { parseDateTime } from "./global-ui/gui-time";
import { GuiButton } from "./global-ui/gui-button";
import GuiCalendar from "./global-ui/gui-calendar";
import CustomTimePicker from "./custom-time-picker";

export default function ScheduleAlertModal({ value, onSave, onCancel }) {
  let [date, setDate] = useState(parseDateTime(value) || new Date());
  let [error, setError] = useState();
  let [isReady, setIsReady] = useState(false);

  let timezone = moment.tz.guess() || "America/New_York";
  let timeZoneLabel = moment().tz(timezone).format("z");

  function updateDate(name, value) {
    let updatedDate = new Date(date);

    if (name === "date") {
      let parsedDate = parseDate(value);
      if (parsedDate) {
        parsedDate.setHours(date.getHours(), date.getMinutes(), 0);
        updatedDate = parsedDate;
      }
    }

    if (name === "time") {
      updatedDate.setHours(value.getHours(), value.getMinutes(), 0);
    }

    setDate(updatedDate);
    setError(null);
  }

  function onContinue() {
    if (date > new Date()) setIsReady(true);
    else setError("Please pick a future date and time.");
  }

  return (
    <>
      {!isReady && (
        <Modal className="schedule-alert-modal">
          <h4>Date</h4>
          <GuiCalendar name="date" value={date} onChange={updateDate} />

          <CustomTimePicker
            name="time"
            value={date}
            onChange={updateDate}
          ></CustomTimePicker>

          <span className="error-msg">{error || "\u00A0"}</span>

          <div className="sc-alert-btn-container">
            <GuiButton
              dataQa="cancel"
              className="btn-outline"
              onClick={onCancel}
            >
              Cancel
            </GuiButton>
            <GuiButton className="continue-btn" onClick={onContinue}>
              <i className="fa fa-clock"></i>
              Schedule
            </GuiButton>
          </div>
        </Modal>
      )}

      {isReady && (
        <Modal className="schedule-alert-modal-ready">
          <h4>Your message is ready!</h4>
          <p className="modal-date">
            Send: {formatDateLongScheduled(date)} {timeZoneLabel}
          </p>

          <div className="scm-btn-container">
            <GuiButton
              dataQa="cancel"
              className="btn-outline"
              onClick={onCancel}
            >
              Cancel
            </GuiButton>
            <GuiButton dataQa="scheduled" onClick={(e) => onSave(date)}>
              Schedule Message
            </GuiButton>
          </div>
        </Modal>
      )}
    </>
  );
}
